import React from 'react'
import { connect } from 'react-redux'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import InfoPanel from '../../components/InfoPanel'
import Szambelan from '../../components/Szambelan'
import { controlHasError } from '../../lib/errorHandler'
import * as actions from '../../store/actions'
import InformacjeUszczegolawiajaceStyle from '../../styles/InformacjeUszczegolawiajaceStyle'
import MainStyle from '../../styles/MainStyle'
import Zalaczniki from './Zalaczniki'
import logo from '../../assets/images/szambelan_informacje_objasnienia.svg'
import RoznicaCITRZiSStyle from '../../styles/RoznicaCITRZiSStyle'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import { czyKwotyWTysiacach } from '../../lib/structureChecker'
import InformacjaDodatkowaPodatekDochodowyOpcjonalna from '../../components/roznicaCITRZis/InformacjaDodatkowaPodatekDochodowyOpcjonalna'

class InformacjeDodatkoweSkonsolidowaneV12 extends React.Component {
  rolledContent = () => {
    return (
      <div>
        W tym miejscu, z podziałem na poszczególne jednostki, należy podać:
        <br /> • opisy oraz pliki załączników składające się na informację
        dodatkową lub inny dokument z art. 48 ustawy o rachunkowości.
        <br /> • rozliczenie różnicy pomiędzy podstawą opodatkowania podatkiem
        dochodowym a wynikiem finansowym (zyskiem, stratą) brutto.
      </div>
    )
  }

  exptandContent = () => {
    return (
      <div>
        {this.rolledContent()}
        <br />
        Pozostałe dokumenty, m.in.:
        <br /> • opinię biegłego rewidenta / sprawozdanie z badania rocznego
        sprawozdania finansowego
        <br /> • uchwałę o podziale zysku bądź pokryciu straty
        <br /> • uchwałę lub postanowienie o zatwierdzeniu rocznego sprawozdania
        finansowego
        <br /> • sprawozdanie z działalności
        <br /> • sprawozdanie z płatności na rzecz administracji publicznej
        <br />
        należy przesłać do urzędu poza strukturą XML pliku e-Sprawozdania
        <br />W ramach rozliczenia różnicy pomiędzy podstawą opodatkowania
        podatkiem dochodowym a wynikiem finansowym brutto należy obowiązkowo
        podać kwoty łączne za rok bieżący. Opcjonalne jest:
        <br />- podanie kwot za rok poprzedni
        <br />- wyszczególnienie kwot przychodów / kosztów z zysków kapitałowych
        <br />
        Ponadto, jeśli kwoty w pozycjach od B. do G. oraz I. są większe bądź
        równe 20 000zł, obowiązkowo należy podać podstawę prawną.
      </div>
    )
  }

  aktualizujSumy = (value, index, name, infoI) => {
    if (!value) value = 0
    let InformacjaPodatkowa = { ...this.props.section.Dane.Pozycje[infoI].InformacjaPodatkowa }
    let sumy = [...InformacjaPodatkowa.Pozycje]
    const getValue = (stateIndex, value, eventIndex, name) => {
      if (stateIndex === eventIndex) return value
      return sumy[stateIndex][name]
    }
    sumy[index][name] = value
    if (name === 'KwotaRP' || name === 'KwotaRB') {
      const kwota =
        getValue(0, value, index, name) -
        getValue(1, value, index, name) -
        getValue(2, value, index, name) +
        getValue(3, value, index, name) +
        getValue(4, value, index, name) +
        getValue(5, value, index, name) -
        getValue(6, value, index, name) -
        getValue(7, value, index, name) +
        getValue(8, value, index, name)
      sumy[9][name] = kwota
    }
    InformacjaPodatkowa.Pozycje = sumy
    this.props.onSetSectionDataArray(InformacjaPodatkowa, infoI, 'InformacjaPodatkowa')
  }

  handleZalacznikAdd = (infoI, structure) => {
    const zalaczniki = [...this.props.section.Dane.Pozycje[infoI].Zalaczniki]
    zalaczniki.push({
      ...structure,
      ...{ Id: Date.now().toString() },
    })
    this.props.onSetSectionDataArray(zalaczniki, infoI, 'Zalaczniki')
  }

  handleZalacznikChange = (v, i, n, infoI) => {
    const zalaczniki = [...this.props.section.Dane.Pozycje[infoI].Zalaczniki]
    zalaczniki[i][n] = v
    this.props.onSetSectionDataArray(zalaczniki, infoI, 'Zalaczniki')
  }

  handleZalacznikDelete = (i, infoI) => {
    const zalaczniki = [...this.props.section.Dane.Pozycje[infoI].Zalaczniki]
    zalaczniki.splice(i, 1)
    this.props.onSetSectionDataArray(zalaczniki, infoI, 'Zalaczniki')
  }

  add = () => {
    let data = [...this.props.sectionList]
    data[0].Dane.Pozycje.push({
      Id: '',
      Nazwa: '',
      Zalaczniki: [],
      InformacjaPodatkowa: [],
    })
    this.props
      .saveSections(this.props.fileId, data)
      .then(() => this.props.downloadSections(this.props.fileId, '16'))
  }

  handlePodatekDochodowySetSectionData = (e, infoI) => {
    const { name, checked } = e.target
    let InformacjaPodatkowa = { ...this.props.section.Dane.Pozycje[infoI].InformacjaPodatkowa }
    InformacjaPodatkowa[name] = checked
    this.props.onSetSectionDataArray(InformacjaPodatkowa, infoI, 'InformacjaPodatkowa')
  }

  render = () => {
    const { validityErrors, onSetPozycjeUzytkownikaSkonsolid, section } = this.props
    let struktura = {
      Nazwa: '',
      Zalaczniki: [],
      InformacjaPodatkowa: [],
    }
    return (
      <MainStyle
        className={
          section.Dane.Pozycje.length > 0 ? '' : 'hide-on-print'
        }
      >
        <InfoPanel
          canExpand={true}
          rolledContent={this.rolledContent()}
          exptandContent={this.exptandContent()}
        />
        <InformacjeUszczegolawiajaceStyle>
          <div className="attachment-header">
            <span>DODATKOWE INFORMACJE I OBJAŚNIENIA</span>
            <ButtonAddInfo
              label="DODAJ JEDNOSTKĘ"
              structure={struktura}
              handleAdd={this.add}
            />
          </div>
          {section.Dane.Pozycje.length > 0 ? (
            <div className="container">
              <div className="listLabel caption">
                <p>NAZWA JEDNOSTKI</p>
              </div>
              {section.Dane.Pozycje.map((data, index) => (
                <ExpandableListElement
                  multiRow={true}
                  placeholder="Nazwa jednostki"
                  name="NazwaJednostki"
                  nazwaPozycji={data.Nazwa}
                  key={index}
                  index={index}
                  hasError={(name, value) =>
                    controlHasError(
                      validityErrors,
                      'NazwaJednostki',
                      value,
                      true,
                    )
                  }
                >
                  <ExpandablePanel
                    title="INFORMACJA DODATKOWA I ZAŁĄCZNIKI"
                    multiRow={true}
                  >
                    <Zalaczniki
                      shortenedView={true}
                      zalaczniki={data.Zalaczniki}
                      onSetSectionDataArray={(v, i, n) =>
                        this.handleZalacznikChange(v, i, n, index)
                      }
                      handleAdd={structure =>
                        this.handleZalacznikAdd(index, structure)
                      }
                      handleDelete={i => this.handleZalacznikDelete(i, index)}
                    />
                  </ExpandablePanel>
                  <ExpandablePanel
                    title="INFORMACJA DODATKOWA DOTYCZĄCA PODATKU DOCHODOWEGO"
                    multiRow={true}
                  >
                    <RoznicaCITRZiSStyle shortenedView={true}>
                      <InformacjaDodatkowaPodatekDochodowyOpcjonalna
                        onSetSectionData={e => this.handlePodatekDochodowySetSectionData(e, index)}
                        onSetSectionDataArray={(v, i, n) => {
                          onSetPozycjeUzytkownikaSkonsolid(index, i, v)
                        }}
                        czyKwotyWTysiacach={this.props.czyKwotyWTysiacach}
                        data={{
                          CzyJestInformacjaOPodatkuDochodowym: data.InformacjaPodatkowa.CzyJestInformacjaOPodatkuDochodowym,
                          Pozycje: data.InformacjaPodatkowa.Pozycje
                        }}
                        aktualizujSumy={(v, i, n) => this.aktualizujSumy(v, i, n, index)}
                      />
                    </RoznicaCITRZiSStyle>
                  </ExpandablePanel>
                </ExpandableListElement>
              ))}
            </div>
          ) : (
              <Szambelan
                logo={logo}
                text={
                  <>
                    Jeszcze nie podano dodatkowych informacji
                  <br /> dla jednostek objętych skonsolidowanym
                  <br /> sprawozdaniem finansowym
                </>
                }
              />
            )}
        </InformacjeUszczegolawiajaceStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    fileId: state.sprawozdanie.header.Id,
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors.filter(
        value => value.TypSekcji === 'InformacjeDodatkoweSkonsolidowane',
      )
      : [],
    czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetSectionDataArray: (v, i, n) => {
      dispatch(actions.setSectionDataArray(v, i, 0, n))
    },
    onAddDetailInfo: (structure, sIndex) => {
      return dispatch(actions.addDetailInfo(structure, sIndex))
    },
    saveSections: (fileId, sections) =>
      dispatch(actions.saveSections(fileId, sections)),
    downloadSections: (fileId, page) =>
      dispatch(actions.downloadSections(fileId, page)),
    onSetPozycjeUzytkownikaSkonsolid: (iInfo, iCIT, v) =>
      dispatch(actions.setPozycjeUzytkownikaSkonsolidV12(iInfo, iCIT, v)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InformacjeDodatkoweSkonsolidowaneV12)
